export default "__VITE_ASSET__1ec5d2cf__"